"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteInAppPurchaseService = exports.authSuiteInAppPurchaseService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../models");
var registerPurchasePath = "access/purchase";
var purchaseAndRegisterSubscription = function (requestPayload) {
    var createDirectPaymentSubscriptionPath = "directPayments/subscriptions";
    var productId = requestPayload.productId, transactionToken = requestPayload.transactionToken, couponCode = requestPayload.couponCode, activationCode = requestPayload.activationCode, referralCode = requestPayload.referralCode, siteKey = requestPayload.siteKey, captchaToken = requestPayload.captchaToken;
    var payload = {
        productId: productId,
        transactionToken: transactionToken,
        couponCode: couponCode,
        referralCode: referralCode,
        siteKey: siteKey,
        captchaToken: captchaToken,
    };
    var body = JSON.stringify(payload);
    var requestParams = activationCode ? [models_1.AuthSuiteSdkClientRequestParams.ActivationCode] : [];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: createDirectPaymentSubscriptionPath,
        requestParams: requestParams,
        request: requestPayload,
    });
};
var registerAppStoreInAppPurchase = function (request) {
    var appStorePath = "".concat(registerPurchasePath, "/appStore");
    var payload = {
        purchaseToken: request.purchaseToken,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: appStorePath,
    });
};
var registerGooglePlayInAppPurchase = function (request) {
    var googlePlayPath = "".concat(registerPurchasePath, "/googlePlay");
    var payload = {
        purchases: request.purchases,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: googlePlayPath,
    });
};
exports.authSuiteInAppPurchaseService = {
    registerAppStoreInAppPurchase: registerAppStoreInAppPurchase,
    registerGooglePlayInAppPurchase: registerGooglePlayInAppPurchase,
    purchaseAndRegisterSubscription: purchaseAndRegisterSubscription,
};
var AuthSuiteInAppPurchaseService = /** @class */ (function () {
    function AuthSuiteInAppPurchaseService() {
        return exports.authSuiteInAppPurchaseService;
    }
    return AuthSuiteInAppPurchaseService;
}());
exports.AuthSuiteInAppPurchaseService = AuthSuiteInAppPurchaseService;
